import { getPublicProductItem } from "../repositories/dataRetrieve";
import { currencyFormat, formatCifra } from "../repositories/utils";
import { useNavigate, useLocation } from 'react-router-dom';
import { DoneAll, Replay } from "@mui/icons-material";
import { no_wa } from "../firebase_setup/firebase";
import { useEffect, useState } from 'react';
import { CircularProgress,
        Typography,
        Button,
        Paper,
        Grid,
        Box } from '@mui/material';
import Carousel from 'react-material-ui-carousel';
import Image from "../static/ImagesProvider";

const CommonProductDetailPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { productId } = location.state || {};
    const [productItem, setProductItem] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [index, setIndex] = useState(0);

    const handleChange = (cur, prev) => {
        setIndex(cur);
    };

    useEffect(() => {
        const getProduct = async () => {
            setIsLoading(true);
            const resp = await getPublicProductItem(productId);

            if (resp?.message?.toUpperCase() === "OK") {
                setProductItem(resp?.data);
                setIsLoading(false);
            } else {
                setProductItem(null);
                setIsLoading(false);
            };
        };

        getProduct();
    }, []);

    return (
        <Box
            sx={{
                backgroundColor: 'rgba(255, 255, 255, 1)',
                margin: 'auto',
                marginTop: {xs: '2vh', md:'5vh'},
                marginBottom: {xs: '2vh', md:'5vh'},
                height: {xs: '85vh', md:'80vh'},
                width: '90vw',
                borderRadius: '20px',
                overflowY: 'auto'
            }}
        >
            {isLoading ?
                <Typography
                    variant="h2"
                    component="div"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        color: 'dimgray',
                        fontFamily: 'Barlow',
                        height: '70vh',
                        placeItems: 'center'
                    }}
                >
                    <CircularProgress sx={{ width: "70px !important", height: "70px !important", color: "#62C21B" }} />
                </Typography>
            :
                <>
                    {productItem ?
                        <Box
                            sx={{
                                width: {xs: '90%', md: '96%'},
                                margin: {xs: '5%', md: '2%'}
                            }}
                        >
                            <Box sx={{ flexGrow: 1, padding: 4 }}>
                                <Grid container spacing={4} alignItems="center">
                                    <Grid item xs={12} md={5}>
                                        {productItem[0].images.length === 0 ?
                                            <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                                <Box
                                                    component="img"
                                                    sx={{
                                                        width: '100%',
                                                        objectFit: 'fill',
                                                        display: 'block'
                                                    }}
                                                    src={Image.NoImage}
                                                />
                                            </Paper>
                                        :
                                            <Carousel
                                                index={index}
                                                onChange={handleChange}
                                                autoPlay={true}
                                                animation="slide"
                                                indicators={false}
                                                navButtonsAlwaysVisible={false}
                                                sx={{ textAlign: '-webkit-center' }}
                                            >
                                                {productItem[0].images.map((item, i) => (
                                                    <>
                                                        {item.type === "image/jpeg" ?
                                                            <Paper key={i} elevation={0} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                                                <Box
                                                                    component="img"
                                                                    sx={{
                                                                        width: { xs: '100%', md: 'auto' },
                                                                        height: { xs: 'auto', md: 300 },
                                                                        display: 'block'
                                                                    }}
                                                                    src={item.url}
                                                                />
                                                            </Paper>
                                                        :
                                                            <video style={{ width: { xs: '100%', md: 'auto' }, height: "300px" }} controls>
                                                                <source src={item.url} type="video/mp4" />
                                                            </video>
                                                        }
                                                    </>
                                                ))}
                                            </Carousel>
                                        }
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                gap: 2,
                                                mt: 2,
                                                justifyContent: 'center',
                                                overflowX: 'auto',
                                                py: 1
                                            }}
                                        >
                                            {productItem[0].images.map((item, i) => (
                                                <Box
                                                    key={i}
                                                    onClick={() => setIndex(i)}
                                                    sx={{
                                                        width: 80,
                                                        height: 60,
                                                        cursor: 'pointer',
                                                        borderRadius: 2,
                                                        overflow: 'hidden',
                                                        border: i === index ? '3px solid #1976d2' : '2px solid transparent',
                                                        opacity: i === index ? 1 : 0.6,
                                                        transition: 'all 0.3s ease',
                                                        '&:hover': { opacity: 1 }
                                                    }}
                                                >
                                                    <Box
                                                        component="img"
                                                        src={item.url}
                                                        alt={`thumb-${i}`}
                                                        sx={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 1}}
                                                    />
                                                </Box>
                                            ))}
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} md={7}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                            <Typography variant="h3" component="h1" fontWeight="bold">
                                                {productItem[0].marca} - {productItem[0].descripcion_corta}
                                            </Typography>

                                            <Typography variant="body1" color="text.secondary" paragraph>
                                                {productItem[0].descripcion_larga}
                                            </Typography>

                                            <Typography variant="body1" color="text.secondary" paragraph>
                                                <b>Línea:</b> {productItem[0].linea}<br />
                                                {/* <b>Piezas en existencia:</b> {formatCifra(productItem[0].existencias) || 0}<br /> */}
                                                <b>Precio en tienda:</b> {currencyFormat.format(parseFloat(productItem[0].precio_dept))}<br />
                                                <b>Descuento:</b> {`${formatCifra(productItem[0].descuento * 100)}%`}<br />
                                                <b>Precio Final:</b> {currencyFormat.format(parseFloat(productItem[0].precio_dept).toFixed(2)*(1-parseFloat(productItem[0].descuento).toFixed(2)))}<br />
                                            </Typography>

                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignSelf: { xs: 'center', md: 'end' },
                                                    gap: 2
                                                }}
                                            >
                                                {Number(productItem[0].existencias) > 0 ?
                                                    <Button
                                                        variant="outlined"
                                                        size="large"
                                                        color="success"
                                                        href={`https://wa.me/52${no_wa}?text=Hola,%20estoy%20interesad@%20en%20el%20artículo%20'${productItem[0].descripcion_corta}'`}
                                                        target="_blank"
                                                        startIcon={<DoneAll />}
                                                    >
                                                        Me interesa
                                                    </Button>
                                                :
                                                    null
                                                }
                                                <Button
                                                    variant="contained"
                                                    size="large"
                                                    color="error"
                                                    onClick={() => navigate(-1)}
                                                    startIcon={<Replay />}
                                                >
                                                    Regresar
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    :
                        <Typography
                            variant="h2"
                            component="div"
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                color: 'dimgray',
                                fontFamily: 'Barlow',
                                height: '70vh',
                                placeItems: 'center'
                            }}
                        >
                            Producto sin información
                        </Typography>
                    }
                </>
            }
        </Box>
    )
}

export default CommonProductDetailPage;
